import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/containers/target-scrollable-container/contexts/target-scrollable-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/containers/target-scrollable-container/target-scrollable-container.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/betslip/betslip.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/breakpoint/components/breakpoint-display-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/odds-page/components/float-bet-slip-button/float-bet-slip-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/odds-page/components/live-streamer-button/live-streamer-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/odds-page/components/virtual-euro-float-button/virtual-euro-float-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/sportsbook-aside/sportsbook-aside.tsx");
